export default "__VITE_ASSET__5UgVrJUV__"